/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['полн.', 'напл.', 'утро', 'претпл.', 'попл.', 'веч.', 'ноќе'],
    [
      'полноќ', 'напладне', 'наутро', 'претпл.', 'попл.',
      'навечер', 'ноќе'
    ],
    [
      'полноќ', 'напладне', 'наутро', 'претпладне',
      'попладне', 'навечер', 'по полноќ'
    ]
  ],
  [
    [
      'полноќ', 'пладне', 'наутро', 'претпл.', 'попл.',
      'навечер', 'по полноќ'
    ],
    [
      'полноќ', 'напладне', 'наутро', 'претпл.', 'попл.',
      'навечер', 'по полноќ'
    ],
    [
      'на полноќ', 'напладне', 'наутро', 'претпладне',
      'попладне', 'навечер', 'по полноќ'
    ]
  ],
  [
    '00:00', '12:00', ['04:00', '10:00'], ['10:00', '12:00'], ['12:00', '18:00'],
    ['18:00', '24:00'], ['00:00', '04:00']
  ]
];
